import Swal from 'sweetalert2';
import {Requestor} from 'hegyd/core/resources/assets/js/utils/Requestor.js';

export default class AjaxSwitch extends HTMLInputElement {

    constructor() {
        super();
        this.route = this.dataset.switchRoute;
        this.method = this.dataset.switchMethod;
    }

    connectedCallback() {
        this.addEventListener("change", e => {
            e.preventDefault();

            let containerCallback = document;
            let callbackSuccess, callbackError;

            if (this.dataset.callbackContainerId) {
                containerCallback = document.getElementById(this.dataset.callbackContainerId);
            }

            if (this.dataset.successCallback !== undefined) {
                if (this.dataset.successCallback.indexOf("window") === 0) {
                    callbackSuccess = new Function(this.dataset.successCallback);
                } else {
                    callbackSuccess = containerCallback[this.dataset.successCallback];
                }
            }

            if (this.dataset.errorCallback !== undefined) {
                if (this.dataset.errorCallback.indexOf("window") === 0) {
                    callbackError = new Function(this.dataset.errorCallback);
                } else {
                    callbackError = containerCallback[this.dataset.errorCallback];
                }
            }

            if (callbackSuccess === undefined && this.dataset.successRedirect) {
                const successRedirect = this.dataset.successRedirect;

                callbackSuccess = function(){
                    window.location.href = successRedirect;
                };
            }

            if (this.dataset.confirm && this.dataset.confirm == "true") {
                const self = this;
                Swal({
                    animation: false,
                    customClass: 'animated fadeIn',
                    title: self.dataset.swalTitle,
                    html: self.dataset.swalText,
                    type: self.dataset.swalType || 'warning',
                    showCancelButton: self.dataset.swalCancelButton || true,
                    confirmButtonText: self.dataset.swalConfirm,
                    cancelButtonText: self.dataset.swalCancel,
                }).then(function (result) {
                    if (result.value) {
                        self.sendAjaxCall(self.route, self.method, callbackSuccess, callbackError);
                    }
                });
            } else {
                this.sendAjaxCall(this.route, this.method, callbackSuccess, callbackError);
            }
        });
    }

    sendAjaxCall(route, method, callbackSuccess, callbackError) {
        var requestor = new Requestor();
        requestor.sendRequest(route, method, {}, callbackSuccess, callbackError);
    }
}
